module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_9005.d364cc57.png";